import controller from './packet-card.controller';

export default {
  bindings: {
    packet: '<',
    discount: '<'
  },
  controller,
  template: require('./packet-card.html')
};



// WEBPACK FOOTER //
// src/app/components/packet-card/packet-card.component.ts